<template>
  <div class="loading-overlay">
    <div class="card">
      <div class="card-body">
        <LoadingSpinner :text="text" />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import LoadingSpinner from './LoadingSpinner.vue';

const { text } = defineProps({
  text: {
    type: String,
    default: '... Daten werden geladen ...'
  }
});

</script>

<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1056; /* Modal has z-index 1055 */
}
</style>